import uiCommonGlobalScript from '/home/jenkins/agent/workspace/mmerce_Squad_ui-embeddables_main/node_modules/ui-common/dist/collection/global/common.js';
import embeddablesGlobalScript from '/home/jenkins/agent/workspace/mmerce_Squad_ui-embeddables_main/src/global/common.ts';
export const globalScripts = () => {
  embeddablesGlobalScript();
  uiCommonGlobalScript();
};
